import React, { useState } from "react";
import { Card, CardBody, Col, Container, Nav, NavItem, NavLink, Row } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import RecordingsAndMeetingsTab from "./RecordingsAndMeetingsTab";
import ManuallyAddedSessions from "./ManuallyAddedSessions";
const classNames = require('classnames');

const ViewMeetingsAndRecordings: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [customActiveTab, setCustomActiveTab] = useState("1");

  const toggleCustom = (tab: string) => {
    if (customActiveTab !== tab) {
      setCustomActiveTab(tab);
    }
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title={`Lavni`} breadcrumbItem={"Recordings & Meetings"} />

            <Card>
              <CardBody>
                <Row>
                  <Col xl="12">
                    <Nav tabs className="nav-tabs-custom nav-justified discover-nav-items">
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classNames({ active: customActiveTab === "1" })}
                          onClick={() => {
                            toggleCustom("1");
                          }}
                        >
                          <span className="d-none d-sm-block">Recordings & Meetings</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classNames({ active: customActiveTab === "2" })}
                          onClick={() => {
                            toggleCustom("2");
                          }}
                        >
                          <span className="d-none d-sm-block">Manually Added Sessions</span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </Col>
                </Row>

                {customActiveTab === "1" && (
                  <RecordingsAndMeetingsTab isLoading={isLoading} setIsLoading={setIsLoading} />
                )}
                {customActiveTab === "2" && (
                  <ManuallyAddedSessions isLoading={isLoading} setIsLoading={setIsLoading} />
                )}
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    </>
  );
};

export default ViewMeetingsAndRecordings;
